<template>
	<button class="button-dashed rounded gap-8 text-gray-300" @click="$emit('click')">
		<BaseIcon v-if="loading" name="mono/load" />
		<slot v-else name="icon" />
		<span>
			<slot />
		</span>
	</button>
</template>

<script>
export default {
	name: 'ButtonShare',
	props: {
		loading: Boolean,
	},
	emits: ['click'],
}
</script>
